
(function() {
  var result = { translations: { "vi": { "i18n": { "duration": { "seconds": "{{ seconds }} gi\xE2y", "minutes": "{{ minutes }} ph\xFAt", "hours": "{{ hours }} gi\u1EDD", "hoursAndMinutes": "{{ hours }} gi\u1EDD {{ minutes }} ph\xFAt", "days": "{{ days }} ng\xE0y", "shortForm": { "seconds": "{{ seconds }} gi\xE2y", "minutes": "{{ minutes }} ph\xFAt", "hours": "{{ hours }} gi\u1EDD", "days": "{{ days }} ng\xE0y", "hoursAndMinutes": "{{ hours }} gi\u1EDD {{ minutes }} ph\xFAt" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, m\xE1y l\u1EBB {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "vi": "static-7.972"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.972",
    "ar-eg": "static-7.972",
    "bg": "static-7.972",
    "bn": "static-7.972",
    "ca-es": "static-7.972",
    "cs": "static-7.972",
    "da": "static-7.972",
    "de": "static-7.972",
    "el": "static-7.972",
    "en-gb": "static-7.972",
    "en": "static-7.972",
    "es-mx": "static-7.972",
    "es": "static-7.972",
    "fi": "static-7.972",
    "fr-ca": "static-7.972",
    "fr": "static-7.972",
    "he-il": "static-7.972",
    "hr": "static-7.972",
    "hu": "static-7.972",
    "id": "static-7.972",
    "it": "static-7.972",
    "ja": "static-7.972",
    "ko": "static-7.972",
    "lt": "static-7.972",
    "ms": "static-7.972",
    "nl": "static-7.972",
    "no": "static-7.972",
    "pl": "static-7.972",
    "pt-br": "static-7.972",
    "pt-pt": "static-7.972",
    "ro": "static-7.972",
    "ru": "static-7.972",
    "sk": "static-7.972",
    "sl": "static-7.972",
    "sv": "static-7.972",
    "th": "static-7.972",
    "tl": "static-7.972",
    "tr": "static-7.972",
    "uk": "static-7.972",
    "vi": "static-7.972",
    "x-pseudo": "static-7.972",
    "zh-cn": "static-7.972",
    "zh-hk": "static-7.972",
    "zh-tw": "static-7.972"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:vi', {version: 'static-7.972'}); }
})();


